import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type PlatformViewProgramBreakdownTable = {
  programId: string
  name: string
  displayName: string
  iconType: string
  color: string
  minimumResolutions: number
  orgProfileId: string
  orgName: string
  logoUrl: string | null
  highPriority: {
    engagementCount: number
    auditedPercentage: number
    avgScore: number
    avgScoreTrend: number | null
    avgVotes: number
    avgVotesTrend: number
    avgTaskScore: number
    avgTaskScoreTrend: number | null
    avgTimeToClose: number
    previousAvgTimeToClose: number
    avgTimeToCloseTrend: number
    withinTargetPercentage: number
    exceedingVotesPercentage: number
    exceedingVotesTrend: number | null
  }
  lowPriority: {
    engagementCount: number
    avgScore: number | null
    avgScoreTrend: number | null
    avgVotes: number | null
    avgVotesTrend: number | null
    avgTaskScore: number | null
    avgTaskScoreTrend: number | null
    avgTimeToClose: number | null
    previousAvgTimeToClose: number | null
    avgTimeToCloseTrend: number | null
    resolvedPercentage: number
    exceedingVotesPercentage: number
    exceedingVotesTrend: number | null
  }
}

type PlatformViewProgramBreakdownResponse = {
  total: number
  breakdown: PlatformViewProgramBreakdownTable[]
}

type PlatformViewProgramBreakdownRequest = {
  startTime?: string
  endTime?: string
  scope?: 'live'
  orderBy: string
  limit: number
  sortDescending: boolean
  cursor: number
  orgProfileId?: string
}

const request = async (
  params: PlatformViewProgramBreakdownRequest
): Promise<PlatformViewProgramBreakdownResponse> => {
  const { data } = await apiClient.get('/int/v3/platform/program-breakdown', {
    params,
  })

  return data
}

export function useGetProgramBreakdown(params: PlatformViewProgramBreakdownRequest) {
  return useQuery<PlatformViewProgramBreakdownResponse>({
    queryKey: ['platform-view-program-breakdown', params],
    queryFn: () => request(params),
    enabled: Boolean(params.startTime && params.endTime),
  })
}
